/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DisciplinaryActionDto } from './disciplinaryActionDto.schema';

export const IReadOnlyListOfDisciplinaryActionDto = zod.array(zod.lazy(() => DisciplinaryActionDto));

export type IReadOnlyListOfDisciplinaryActionDto = zod.input<typeof IReadOnlyListOfDisciplinaryActionDto>;
export type IReadOnlyListOfDisciplinaryActionDtoOutput = zod.output<typeof IReadOnlyListOfDisciplinaryActionDto>;
